import React, { useEffect, useState } from 'react'

/** Scroll-to-top button, appears bottom-right after 2 viewports (Parity V2 A.8). */
const ScrollToTop: React.FC = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 2)
    window.addEventListener('scroll', onScroll, { passive: true })
    onScroll()
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Scroll to top"
      className={`fixed bottom-[calc(max(0.75rem,env(safe-area-inset-bottom))+3rem)] right-4 md:bottom-6 md:right-6 z-40 flex items-center justify-center w-11 h-11 border border-accent-gold/60 bg-primary-ink/80 backdrop-blur-sm text-accent-gold hover:bg-accent-gold hover:text-primary-ink transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-accent-gold/50 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
      </svg>
    </button>
  )
}

export default ScrollToTop
